<template>
  <div class="d-flex">
    <div :class='shapeName' :style="shapeColor"></div>
    <span class="textPosition">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    shape: {
      type: Object,
      default: function() {
        return {
          name: 'square',
          color: '#FFF'
        }
      }
    },
    text: String
  },
  computed: {
    shapeName() {
      return `${this.shape.name}-legend legend`
    },
    shapeColor() {
      return {
        backgroundColor: this.shape.color
      }
    }
  }
}
</script>

<style scoped>
  .legend {
    padding: 5px;
    max-width: 12px;
    width: 12px;
    height: 12px;
  }

  .square-legend {
    border-radius: 2px;
  }

  .circle-legend {
    border-radius: 50%;
  }

  .textPosition {
    margin-right: 15px;
    margin-top: -4px;
    margin-left: 6px;
  }
</style>
